import {t} from "@lingui/core/macro";

import {isActivitiesPage} from "@repo/guide-core-helpers";
import {UserPersona, type Conversation} from "@repo/guide-types";

/**
 * Add an intro message if the teacher has switched personas.
 *
 * @param conversation The conversation to be modified.
 * @param pathname The pathname of the current page.
 * @param teacherHasToggledPersona Whether the teacher has toggled personas.
 * @param persona The persona the teacher has toggled to.
 * @returns The updated conversation if the teacher has toggled personas and is
 * not on the activities page; otherwise, the original, unchanged conversation.
 */
export const updateConversationForTeacherPersona = (
    conversation: Conversation,
    pathname: string,
    teacherHasToggledPersona: boolean,
    persona?: UserPersona | null,
): Conversation => {
    // If the teacher hasn't used the toggle, doesn't have a persona set, or
    // they are on the activities page, we don't want to show the intro message.
    if (isActivitiesPage(pathname) || !persona || !teacherHasToggledPersona) {
        return conversation;
    }

    // Prepend the conversation with a message specific to the persona the
    // teacher has toggled to.
    const text =
        persona === UserPersona.Teacher
            ? t`Back to your teacher chat!

You have your full capabilities again, and I’ll be the best Teacher’s Guide I can!`
            : t`This is your Student view!

**I will respond as I would to any of your students.** Give me a spin!`;
    return [
        {
            interactionId: "",
            type: "incoming",
            uiOnly: true,
            serverOnly: false,
            user: "Student",
            text,
        },
        ...conversation,
    ];
};
